import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, formValueSelector } from "redux-form";
import { Form, Modal, FormGroup } from "react-bootstrap";

import Button from "../../../../components/common/button/Button";
import AddFilterBox from "./AddFilterBox";
import styles from "./Filters.scss";

import { searchCitiesAutocomplete } from "../../../../actions/cities.actions";
import {
  fetchIndustries,
  fetchReferrals,
  getCommuteCities,
  getLevels
} from "../../../../actions/dropdowns.actions";
import { fetchSkills, getCategories } from "../../../../actions/skills.actions";
import { getUserStatusList } from "../../../../actions/user.actions";

import { getFilterFromRouteState } from "../../../../utils/parseQueries";

class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: props.show || false
    };

    this.handleClose = this.handleClose.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
  }

  componentDidMount() {
    this.props.getUserStatusList();
    this.props.getCategories();
    this.props.fetchSkills();
    this.props.getCommuteCities();
    this.props.getReferralTypes();
    this.props.getLevels();
    this.props.getIndustries();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show) {
      this.setState({ show: nextProps.show });
    }
  }

  handleClose() {
    this.setState({ show: false }, this.props.onClose);
  }

  applyFilters() {
    this.handleClose();
  }

  render() {
    const { submitting, valid } = this.props;

    return (
      <Modal
        show={this.state.show}
        onHide={this.handleClose}
        dialogClassName={styles.modalContainer}
      >
        <Modal.Body className={styles.modalBody}>
          <Form onSubmit={this.props.handleSubmit}>
            <FormGroup>
              <div className={styles.title}>Filter Member Table</div>
              <div className={styles.dividerDouble} />
              <div className={styles.subtitle}>
                Find just what you’re looking for by creating filters for your
                current data set.
              </div>
              <div className={styles.filtersContainer}>
                <AddFilterBox
                  name="filters"
                  addText="Add Filter"
                  statusOptions={this.props.status}
                  cities={this.props.cities}
                  onSearchCities={this.props.searchCitiesAutocomplete}
                  isLoadingCities={this.props.isLoadingCities}
                  skillsCategoriesOptions={this.props.categories}
                  skillsOptions={this.props.skills}
                  selectedSkillCategory={this.props.skillCategory}
                  selectedLocation={this.props.location}
                  commuteCitiesOptions={this.props.commuteCities}
                  referralTypesOptions={this.props.referralTypes}
                  levelsOptions={this.props.levels}
                  industriesOptions={this.props.industries}
                />
              </div>
            </FormGroup>

            <div className={styles.dividerDouble} />

            <div className={styles.CTAContainer}>
              <Button
                isPrimary
                type="submit"
                label="View Results"
                onClick={this.applyFilters}
                isDisabled={!valid || submitting}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

Filters = reduxForm({
  form: "usersTableFilters",
  enableReinitialize: true,
  destroyOnUnmount: true
})(Filters);

const selector = formValueSelector("usersTableFilters");
const getChild = _.property("skill_category");
const getLocation = _.property("location");
Filters = connect(
  state => {
    let skillCategory;
    const skillCategorySelector = selector(state, "filters");
    if (skillCategorySelector) {
      skillCategory = skillCategorySelector
        .map(getChild)
        .filter(e => e === 0 || e);
    }

    let location;
    const locationSelector = selector(state, "filters");
    if (locationSelector) {
      location = locationSelector.map(getLocation).filter(e => e === 0 || e);
      if (location && location.length > 0) {
        location = location[0];
      }
    }

    return {
      skillCategory,
      location,
      status: state.user.userStatusList,
      cities: state.cities.cities.predictions,
      isLoadingCities: state.cities.cities.isLoading,
      categories: state.skills.categories.data,
      skills: state.skills.skills.data,
      commuteCities: state.dropdowns.commuteCities.data,
      referralTypes: state.dropdowns.referrals.data,
      levels: state.dropdowns.levels.data,
      industries: state.dropdowns.industries.data,
      initialValues: getFilterFromRouteState(state, "filters")
    };
  },
  dispatch => {
    return {
      getUserStatusList: () => dispatch(getUserStatusList()),
      searchCitiesAutocomplete: query =>
        dispatch(searchCitiesAutocomplete(query)),
      getCategories: () => dispatch(getCategories()),
      fetchSkills: () => dispatch(fetchSkills()),
      getReferralTypes: () => dispatch(fetchReferrals()),
      getCommuteCities: () => dispatch(getCommuteCities()),
      getLevels: () => dispatch(getLevels()),
      getIndustries: () => dispatch(fetchIndustries())
    };
  }
)(Filters);

export default Filters;



// WEBPACK FOOTER //
// ./src/routes/admin/users/components/Filters.js